/* eslint-disable no-unused-vars */
import React, { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './css/Products1.css';
import { useHistory } from 'react-router-dom';
import { context } from '../../../globalState/GlobalState';
import ProductThumbnail5 from '../../uiElements/productThumbnails/productThumbnail5/ProductThumbnail5';

const FeaturedProducts3 = (props) => {
    const { products, title } = props;
    const { globalState } = useContext(context);
    const history = useHistory();

    const settingsDesktop = {
        autoplay: true,
        autoplaySpeed: 2500,
        speed: 500,
        infinite: products.length > 3,
        slidesToShow: products.length > 2 ? 3 : 4,
        slidesToScroll: 1,
        centerMode: true,
    };

    const settingsMobile = {
        autoplay: true,
        autoplaySpeed: 2500,
        speed: 500,
        infinite: products.length > 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
    };

    return (
        <>
            {products.length > 0 ? (
                <div className="featured-products3-container">
                    <div
                        className={`featured-products3-title-box ${history.location.pathname.startsWith('/store') ? '' : 'pointer'}`}
                        onClick={() => {
                            if (!history.location.pathname.startsWith('/store')) {
                                history.push('/store');
                            }
                        }}
                    >
                        <img src={globalState.logo.logo2} alt="logo" className="featured-products3-logo" />
                        <p className="featured-products3-title">{title}</p>
                    </div>
                    <div className="featured-products3-products-container desktop">
                        <Slider {...settingsDesktop}>
                            {
                                products.map((product) => {
                                    return (
                                        <ProductThumbnail5 key={product.id} product={product} />
                                    );
                                })
                            }
                        </Slider>
                    </div>
                    <div className="featured-products3-products-container mobile">
                        <Slider {...settingsMobile}>
                            {
                                products.map((product) => {
                                    return (
                                        <ProductThumbnail5 key={product.id} product={product} />
                                    );
                                })
                            }
                        </Slider>
                    </div>
                </div>
            ) : null}
        </>
    );
};

FeaturedProducts3.propTypes = {
    products: PropTypes.array.isRequired,
    title: PropTypes.string,
};

FeaturedProducts3.defaultProps = {
    title: 'Featured Products',
};

export default FeaturedProducts3;
